import React, { Component } from 'react';
import './css/Actividad.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome' 
import BootstrapTable from 'react-bootstrap-table-next';
import { Modal, Col, Row, Container } from 'react-bootstrap';
import { Solicitud_generica } from './expand/Solicitud_generica';
import { Nueva_actividad } from './modal/Nueva_actividad';
import { faUserCheck, faUserEdit, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import eliminar from './../img/svg/Eliminar.svg';
import crear from './../img/svg/Nueva.svg';
import editar from './../img/svg/Editar.svg';
import Swal from 'sweetalert2'
const API_URL = process.env.REACT_APP_API_URL;

function color_head() {
    return {
        backgroundColor: '#25223f',
        color: 'white',
        width: '20%', fontSize: 11,
    };
}
function color_head_desc(tipo) {
    if (tipo == 'a') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '50%'
        };
    } else if (tipo == 'd') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        }
    } else if (tipo == 'id') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '5%'
        };
    } else {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        };
    }
}
//Funcion para colocar color a las celdasde la tabla
function color(rowIndex) {
    if (rowIndex % 2 === 0) {
        return {
            backgroundColor: 'white'
        };
    }
    return {
        backgroundColor: '#E7E7E7'
    };
}

export class Solicitud_General extends Component {
    static displayName = Solicitud_General.name;

    handleBtnClick = () => {
        if (!this.state.expanded.includes(0)) {
            this.setState(() => ({
                expanded: [...this.state.expanded, 0]
            }));
        } else {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== 0)
            }));

        }
    }

    handleOnExpand = (row, isExpand, rowIndex, e) => {
        if (isExpand) {
            this.setState(() => ({
                expanded: [...this.state.expanded, row.id]
            }));
        } else {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== row.id)
            }));
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            actividades: [], loading: false, loading2: false, accion: "", fila: [], expanded: [], id_row: 0,
            anio: props.anio, idpersona: props.idprof, periodo: "", newactividad: "", observacion: "", actividades_combo: [],
            nuevoregistro: [], selectact: "", selectidact: "", abierto: false, solicitudes: [], valida_next: false
        };

        this.actualizarSolicitudes = this.actualizarSolicitudes.bind(this);
        this.deleteActivity = this.deleteActivity.bind(this);
        this.editActivity = this.editActivity.bind(this);
        this.updatestate = this.updatestate.bind(this);
        this.updatestate_solicitud = this.updatestate_solicitud.bind(this);
    
    }

    componentDidMount() {
        if (this.props.getSolicitudes('')) {
            this.setState({
                actividades: this.props.getSolicitudes('todo bien')
            })
        }

        if (this.state.idpersona > 0) {
            this.populateActividadesCombo(this.state.idpersona, this.state.anio);
        }
    }


    /////FUNCIONES para interactuar con los si/no de ACtividades
    handleHideClick = (idUnico) => {
        let obj = this.state.fila.find((o, i) => {
            if (o.idUnico === idUnico) {
                this.state.fila[i].validacion = 'si'
                return this.state.fila[i];
            }
        });
        if (obj == null) {
            this.state.fila.push({
                idUnico: idUnico,
                validacion: 'si'
            })
        }
        if (this.state.expanded.includes(idUnico)) {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== idUnico)
            }));
        }

    }

    handleShowClick = (idUnico) => {
        //console.log(idUnico)
        this.setState({
            id_row: idUnico
        })

        //console.log(idactividad)
        if (!this.state.expanded.includes(idUnico)) {

            let obj = this.state.fila.find((o, i) => {
                if (o.idUnico === idUnico) {
                    this.state.fila[i].validacion = 'no'
                    return this.state.fila[i];
                }
            });
            if (obj == null) {
                this.state.fila.push({
                    idUnico: idUnico,
                    validacion: 'no'
                })
            }
            this.setState(() => ({
                expanded: [...this.state.expanded, idUnico]
            }));
        }
    }

    //funcion para click en update delete
    deleteActivity(rowindex) {
        
        Swal.fire({
            title: '¿Está seguro de eliminar?',
            text: "Usted podría perder el registro de esta observación",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                //console.log("solicitud a eliminar: ", this.state.actividades[rowindex]);
                this.props.setSolicitudes(rowindex, 0, true, this.state.actividades[rowindex].idUnico, this.state.actividades[rowindex].ambito);

                this.actualizarSolicitudes();

                Swal.fire({
                    icon: 'success',
                    text: 'Su observación de asignatura/actividad ha sido eliminada',
                    title: 'Eliminado',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }) 
         
    }

    //funcion para click en update delete
    editActivity(idactividad) {
        this.setState({
            id_row: idactividad
        })
        this.handleShowClick()
        //if (!this.state.expanded.includes(idactividad)) {
             
        //    this.setState(() => ({
        //        expanded: [...this.state.expanded, idactividad]
        //    }));
        //}

        //esto envia al padre los datos para enviarlos luego
        //this.props.setSolicitudes(rowindex)
        //this.actualizarSolicitudes()
    }

    //funcion para click en update delete
    handleClick = (text) => {
        //console.log('accion:', text);
        this.setState({
            accion: text,
        });
    }

    onChangeValue(event) {
        this.setState({
            accion: event.target.value,
        });
    }
    
    actualizarSolicitudes() {
        const solicitudes = this.props.getSolicitudes('todobien');
        //console.log("solicitudes solicitud_general: ", solicitudes);
        //console.log('DATOS DE GETSSOLICITUDES TRIDAS DESDE WIZARD A SOLICITUD GENERAL--->' + JSON.stringify(solicitudes))

        if (solicitudes) {
            this.setState({
                actividades: solicitudes
            })
            //console.log('las solicitudes son:' + JSON.stringify( this.state.actividades))
        }
    }

    updatestate(rowIndex, idactividad, descripcion, totalhoras, anio, terminos, tipoactividad, observacion, pao1, pao2, pae, accion) {
        var solicitudes = this.state.solicitudes
        
        if (solicitudes.length == 0) {
            solicitudes = []
        } else {
            solicitudes = this.state.solicitudes.filter(x => x.idactividad != idactividad)
        }

        solicitudes.push({
            idactividad: idactividad, descripcion: descripcion, totalhoras: totalhoras, anio: anio, termino: terminos, tipoactividad: tipoactividad, observacion: observacion, pao1: pao1, pao2: pao2, pae: pae, accion: accion
        })
        this.setState({
            solicitudes: solicitudes
        });
        //console.log(solicitudes)
        //this.isValidated_all(this.states.fila.length)
        this.props.update({ ambito: tipoactividad, idactividad: idactividad, descripcion: descripcion, totalhoras: totalhoras, anio: anio, termino: terminos, tipoactividad: tipoactividad, observacion: observacion, pao1: pao1, pao2: pao2, pae: pae, accion: accion });

    }

    updatestate_solicitud(ROWID, observacion,accion) {

        //console.log('RECIBIENDO Y ENVIANDOO EN SOLIICITUD GENERAL EL CAMMBIO de OBS: ' + observacion + ' PARA RELIZARLO A ' + ROWID)

        const solicitudes = this.props.updateFinal(ROWID, observacion, accion);
        //console.log('solicitudes updatestate_solicitud: ', solicitudes);
            
        if (solicitudes) {
            this.setState({ actividades: solicitudes });
            //console.log('las solicitudes cambiadas son:' + JSON.stringify(this.state.actividades))
        }

    }


    formatter = (valor) => {
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: '2', minimumFractionDigits: '2', signDisplay: 'never' }).format(valor)
    }

    dateFormatter = (strFecha) => {
        var options = { year: 'numeric', month: '2-digit', day: 'numeric' };
        var dtFecha = new Date(strFecha);
        return dtFecha.toLocaleDateString("es-EC", options);
    }

    toggle = () => {
        this.setState({ abierto: !this.state.abierto });
    }

    render() {

        const buttonToLink = {
            fontSize: '0.65em',
            textAlign: 'left',
            float: 'right',
            color: '#58A7E0',
            background: 'none',
            margin: 0,
            padding: 0,
            border: 'none',
            cursor: 'pointer',
            ":hover": {
                color: "yellow"
            }
        };
        const columns_acti = [
            {
                dataField: 'id',
                text: '#',

                headerStyle: color_head_desc('id'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                formatter: (cellContent, row, rowIndex) => {
                    return (
                        <div>
                            {rowIndex + 1}
                        </div>
                    )
                }
            },
            {
                dataField: 'ambito',
                text: 'Ámbito',
                headerStyle: color_head(),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: '',
                formatter: (cellContent, row, rowIndex) => {
                    var ambito = row.ambito.split('|')[1];
                    if (ambito === "R") {
                        return (<div>Docencia Grado</div>)
                    } else if (ambito === "P") {
                        return (<div>Docencia PostGrado</div>)
                    } else if (ambito === "V") {
                        return (<div>Vinculacion</div>)
                    } else if (ambito === "I") {
                        return (<div>Investigacion</div>)
                    } else if (ambito === "G") {
                        return (<div>Gestion Academica</div>)
                    } else if (ambito === "A") {
                        return (<div>Admisiones</div>)
                    }
                    
                }
            },
            {
                dataField: 'idactividad',
                text: '#',
                hidden: true,
                headerStyle: color_head_desc('id'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            }, {
                dataField: 'descripcion',
                text: 'Asignatura/Actividad',
                headerStyle: color_head_desc('d'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            }, {
                dataField: 'observacion',
                text: 'Observación',
                headerStyle: color_head_desc('a'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            },
            {
                dataField: 'termino',
                text: 'Periodo',
                headerStyle: color_head(),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                formatter: (cellContent, row) => {
                    var respu;
                    if (row.termino.trim() === "1" || row.termino.trim() === "1S") {
                        return (
                            'PAO-' + row.anio + '-1'
                        );
                    } else if (row.termino.trim() === "2" || row.termino.trim() === "2S") {
                        return (
                            'PAO-' + row.anio + '-2'
                        );

                    } else if (row.termino.trim() === "3" || row.termino.trim() === "3S") {
                        return (
                            'PAE-' + row.anio
                        );

                    } else {
                        if (row.accion.toUpperCase() === 'NUEVA CARGA') {
                            let tam = row.termino.split('\n').length;
                            //console.log('TAMOANIO DE NUEVA CARGA' + tam)
                            if (tam == 1) {
                                return (<>{row.termino.split('\n')[0]}</>);
                            } if (tam == 2) {
                                return (<>{row.termino.split('\n')[0]}<br />{row.termino.split('\n')[1]}</>);
                            } else  {
                                return (<>{row.termino.split('\n')[0]}<br />{row.termino.split('\n')[1]}<br />{row.termino.split('\n')[2]}</>);
                            }
                        }  else {
                            return (
                                row.termino.trim()
                            );
                        }
                    }
                },
                footer: ''
            },
            {
                dataField: 'accion', //'Tipo de Observacion'
                text: 'Acción',
                headerStyle: color_head(),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                formatter: (cellContent, row) => {
                    return (<><span className="badge badge-pill badge-warning">{row.accion.toUpperCase()}</span></>);
                },
                footer: ''
            }, {
                dataField: 'totalhoras',
                text: 'Horas',
                hidden:true,
                headerStyle: color_head(),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footerAlign: 'left',
                footer: columnData => {
                    const total2 = columnData.reduce((acc, item) => (Number(acc) + Number(item)).toFixed(2), 0);
                    return (<>Subtotal: {total2} horas</>);
                },


            },
            {
                dataField: 'conformidad',
                text: '',
                isDummyField: true,
                formatter: (cellContent, row) => {
                    return (
                        <div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name={"inlineRadioOptions" + row.idactividad} id="inlineRadio1" value="option1" />
                                <label className="form-check-label" htmlFor="inlineRadio1">Si</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name={"inlineRadioOptions" + row.idactividad} onChange={this.handleBtnClick} id="inlineRadio2" value="option2" />
                                <label className="form-check-label" htmlFor="inlineRadio2">No</label>
                            </div>
                        </div>


                    );
                },
                headerStyle: color_head(),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                formatter: (cellContent, row, rowIndex) => {
                    return(
                            <div className="form-check-despl">
                            <FontAwesomeIcon icon={faEdit} className="icon-cursor" name={'SG' + rowIndex} onClick={() => this.handleShowClick(row.idUnico)} style={{ color: '#58A7E0' }} size="2x" />
                                        &nbsp;&nbsp;|&nbsp;&nbsp;
                            <FontAwesomeIcon icon={faTrash} className="icon-cursor" name={'SG' + rowIndex} onClick={() => this.deleteActivity(rowIndex)} style={{ color: '#58A7E0' }} size="2x" />
                            </div>
                        
                         
                    )

                }
            }];

        const totalpepa2 = this.state.actividades ? this.state.actividades.map(horastot2 => horastot2.totalhoras).reduce((acc2, item2) => (Number(acc2) + Number(item2)), 0) : 0;
        const talambito = this.formatter(totalpepa2);


        const expandRow = {
            onlyOneExpanding: true,
            expanded: this.state.expanded,
            expandByColumnOnly: true,
            renderer:( row,rowIndex) => (
                <div>
                    <Solicitud_generica rowindex={rowIndex} idactividad={row.idactividad} descripcion={row.descripcion}
                        observacion={row.observacion} totalhoras={row.totalhoras} termino={row.termino} accion={row.accion}
                        updatestate_solicitud={this.updatestate_solicitud} handleHideClick={this.handleHideClick} idUnico={row.idUnico} />
                </div>
            )
        };

        return (
            <div>
                {this.state.actividades.length  > 0 ?
                    <div>
                        <Row>
                            <Col md="6">
                                <h4 className='resumen'>RESUMEN GENERAL DE OBSERVACIONES</h4>
                            </Col>
                            <Col md="4"><hr />
                            </Col>

                            <Col md="2"> <button style={buttonToLink} onClick={() => this.toggle()}><img className="new-logo" src={crear} />Nueva Actividad</button>

                            </Col>

                            <p><br/></p>
                        </Row>

                        <BootstrapTable
                            id='Actividades_finales'
                            keyField='idUnico'
                            data={this.state.actividades}
                            columns={columns_acti}
                            bordered={false}
                            expandRow={expandRow}
                        />

                        <Row>
                            <Col md="12">
                                <h4 className='resumen2'> <FontAwesomeIcon icon={faUserEdit} className="icon-cursor" style={{ color: '#ffdb00' }} size="1x" />  SÍ, estoy de acuerdo con todas las actividades/asignaturas planificadas  con excepción de las anteriores observaciones.</h4>
                            </Col>
                        </Row>

                        <p></p>
                    </div> :  /*EN EL CASO QUE NO HAYA SOLICITUDES DE CAMBIO*/
                    <div>
                        <Row>
                            <Col md="5">
                                <h4 className='resumen'>RESUMEN GENERAL DE OBSERVACIONES</h4>
                            </Col>
                            <Col md="4"><hr />
                            </Col>

                            <Col md="3"> <button style={buttonToLink} onClick={() => this.toggle()}><img className="new-logo" src={crear} />Nueva Actividad</button>

                            </Col>
                        </Row>
                         
                        <h5>No hay observaciones</h5>
                        
                        <p><br/></p>
                        <Row>
                            <Col md="12">
                               
                                <h4 className='resumen2'> <FontAwesomeIcon icon={faUserCheck} className="icon-cursor" style={{ color: '#42d300' }} size="1x" /> Estoy de acuerdo con todas las actividades/asignaturas planificadas.</h4>
                            </Col>
                        </Row>

                        <p></p>
                    </div>
                }
              
                <div>

                    <Nueva_actividad actividades_combo={this.state.actividades_combo} anio={this.props.anio} abierto={this.state.abierto} toggle={this.toggle} tipoactividad='S|N' updatestate={this.updatestate} terminoPeriodo={this.props.terminoPeriodo} />

                </div>


            </div>
        );
    }

    async populateActividadesCombo(idpersona, anio) {
        const response = await fetch(API_URL + 'TblActividades/' + anio + '/T/token');
        const respuesta = await response.json();
        const data = respuesta;
        this.setState({ actividades_combo: data, loading: false });
    }
}
